import { Controller } from "@hotwired/stimulus"

// Retrai o menu lateral para um trilho de icones. O estado vive no
// localStorage para sobreviver a navegacao; e preferencia do dispositivo,
// nao da conta — de proposito.
//
// No modo retraido, passar o mouse num item mostra um pill com o titulo.
// O pill e position:fixed no <body> (nao dentro do menu) de proposito: o
// trilho tem overflow proprio e cortaria qualquer tooltip absoluto.
export default class extends Controller {
  static targets = ["chevron"]

  connect() {
    let colapsado = false
    try { colapsado = localStorage.getItem("sidebar") === "colapsado" } catch (_) {}
    if (colapsado) this.element.classList.add("sidebar-collapsed")
    this.instalarTooltip()
  }

  disconnect() {
    this.pill?.remove()
  }

  toggle() {
    const colapsado = this.element.classList.toggle("sidebar-collapsed")
    try { localStorage.setItem("sidebar", colapsado ? "colapsado" : "aberto") } catch (_) {}
  }

  instalarTooltip() {
    this.pill = document.createElement("div")
    this.pill.className = "menu-tooltip"
    this.pill.hidden = true
    document.body.appendChild(this.pill)

    this.element.querySelectorAll(".menu a[title], .menu form[title], .menu button[title]").forEach((item) => {
      // O title nativo sai de cena: alem de lento, brigaria com o pill.
      item.dataset.rotulo = item.getAttribute("title")
      item.removeAttribute("title")

      item.addEventListener("mouseenter", () => {
        if (!this.element.classList.contains("sidebar-collapsed")) return
        const area = item.getBoundingClientRect()
        this.pill.textContent = item.dataset.rotulo
        this.pill.style.top = `${area.top + area.height / 2}px`
        this.pill.style.left = `${area.right + 10}px`
        this.pill.hidden = false
      })
      item.addEventListener("mouseleave", () => { this.pill.hidden = true })
    })
  }
}
